import { WTROK0 } from "./WTROK0";

export function WTROKI () {
    return <h2 className="text-white">I</h2>
}